import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Pressable, Text, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { memo, useState } from "react";

import Accordion from "components/Accordion";
import { FlashList } from "@shopify/flash-list";
import VText from "components/VText";

const DropDown = ({ item, prefAnswers = [], setPrefAnswers = () => {}, answerkey = "dropDown" }) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedOptions = prefAnswers?.[answerkey] || [];

    const rotate = useSharedValue(0);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));

    return (
        <View
            style={{
                marginBottom: spV(30),
            }}
        >
            <VText
                text={item?.question}
                style={{
                    fontSize: fp(16),
                    paddingBottom: hp(8),
                    fontWeight: "500",
                }}
            />
            <Pressable
                style={{
                    paddingVertical: hp(8),
                    paddingHorizontal: wp(16),
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingLeft: 0,
                    borderBottomWidth: 1,
                    flex: 1,
                    width: "100%",
                    borderColor: "rgba(33, 36, 39, 0.16)",
                }}
                onPress={() => {
                    setIsOpen((prev) => {
                        if (prev) {
                            rotate.value = withTiming(0);
                            return false;
                        } else {
                            rotate.value = withTiming(180);
                            return true;
                        }
                    });
                }}
            >
                {selectedOptions?.length == 0 && <VText text={"Select Size"} />}
                {selectedOptions?.length > 0 && (
                    <View
                        style={{
                            flex: 1,
                        }}
                    >
                        <VText
                            text={`Selected: ${selectedOptions?.map((o, idx) => ` ${o?.optionName}`)}`}
                            style={{
                                color: "rgba(33, 36, 39, 0.6)",
                                fontSize: fp(16),
                            }}
                        />
                    </View>
                )}
                <Animated.View style={animatedStyles}>
                    <Svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <Path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0.758301 0.97257L1.73282 -0.00195312L6.7583 5.02352L11.7838 -0.00195312L12.7583 0.97257L6.7583 6.97257L0.758301 0.97257Z"
                            fill="#212427"
                            fill-opacity="0.3"
                        />
                    </Svg>
                </Animated.View>
            </Pressable>
            <Accordion
                style={{
                    maxHeight: hp(500),
                }}
                viewKey={`dropdown_${answerkey}`}
                isExpanded={isOpen}
            >
                <View
                    style={{
                        paddingHorizontal: spH(20),
                        paddingVertical: spV(16),
                        maxHeight: hp(500),
                    }}
                >
                    <FlashList
                        data={item?.options || []}
                        estimatedItemSize={100}
                        numColumns={2}
                        scrollEnabled={false}
                        extraData={prefAnswers}
                        keyExtractor={(item, index) => index.toString()}
                        renderItem={({ item }) => {
                            const isSelected =
                                prefAnswers?.[answerkey]?.find((o) => o?.optionId == item?.optionId) || false;

                            return (
                                <Pressable
                                    style={{
                                        marginBottom: hp(12),
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                    onPress={() => {
                                        setPrefAnswers((prev) => ({
                                            ...prev,
                                            [answerkey]: isSelected
                                                ? prefAnswers?.[answerkey]?.filter((o) => o?.optionId != item?.optionId)
                                                : [...(prefAnswers?.[answerkey] || []), item],
                                        }));
                                    }}
                                >
                                    {!isSelected && (
                                        <View
                                            style={{
                                                width: wp(20),
                                                height: wp(20),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                                borderRadius: 2,
                                                paddingLeft: spH(8),
                                            }}
                                        />
                                    )}
                                    {isSelected && (
                                        <View
                                            style={{
                                                width: wp(20),
                                                height: wp(20),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                                borderRadius: 2,
                                                backgroundColor: "rgba(33, 36, 39, 1)",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Svg
                                                width="11"
                                                height="9"
                                                viewBox="0 0 11 9"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <Path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M10.0999 1.57583L3.37032 8.30541L0 4.67584L1.37399 3.39999L3.42033 5.60375L8.77408 0.25L10.0999 1.57583Z"
                                                    fill="white"
                                                />
                                            </Svg>
                                        </View>
                                    )}
                                    <VText
                                        text={item?.optionName?.slice(0, 30) || ""}
                                        style={{
                                            paddingTop: hp(8),
                                            fontSize: fp(16),
                                            textAlign: "center",
                                            paddingLeft: spH(8),
                                            color: "rgba(33, 36, 39, 0.6)",
                                            textTransform: "capitalize",
                                            fontWeight: "350",
                                        }}
                                        numberOfLines={1}
                                    />
                                </Pressable>
                            );
                        }}
                    />
                </View>
            </Accordion>
        </View>
    );
};

export default memo(DropDown);
